"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.DragItem = function (_a) {
    var children = _a.children, value = _a.value;
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.DragItem.displayName = "DragItem";
